import {defaultTheme} from "../themes/default";
import {regularTheme} from "../themes/regular";

export const themes = {
  //initial theme
  regular: regularTheme,
  //default from config
  default: defaultTheme,
}